import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import _ from 'lodash';

import dashboardIcon from '../../assets/images/dashboard.svg';
import trello from '../../assets/images/trello.svg';
import asana from '../../assets/images/asana.svg';
import jira from '../../assets/images/jira.svg';
import azure from '../../assets/images/devops.svg';
import file from '../../assets/images/nave.svg';

import './Apps.scss';

const icons = {
  jira,
  trello,
  asana,
  azure,
  file,
};

class Apps extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      popupVisible: false,
    };
  }

  handleClick() {
    if (!this.state.popupVisible) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      popupVisible: !prevState.popupVisible,
    }));
  }

  handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }

    this.handleClick();
  }

  prepareUrl = (link, path = '', query = {}) => {
    const queryParams = _.keys(query)
      .filter(k => !!query[k])
      .map((k, i) => (i ? '': '?') + `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
      .join('&');
    const url = `${link}/${path}${queryParams}`;
    return url;
  }

  renderApp = (appname) => {
    const { appAccounts, id } = this.props.user;
    const urlParts = window.location.host.split('.');
    let link = `https://${appname}.${urlParts[1]}.${urlParts[2]}`;

    const appExists = appAccounts && appAccounts.length && _.find(appAccounts, app => !!app.linkedAccountId && !!app.linkedUserId);
    const connected = appAccounts && appAccounts.length && _.find(appAccounts, app => app.app === appname);

    if (appExists) {
      if (appname === 'file') {
        if (!connected) return;
        link = `${link}`;
      } else {
        link = connected ? `${link}` : this.prepareUrl(link, 'api/integrations/login', { account: appExists.linkedAccountId, user: appExists.linkedUserId, from: appExists.app, path: '/'});
      }
    } else {
      if (appname === 'file') {
        link = `${link}/register?uid=${id}`;
      } else {
        link = `${link}/login?uid=${id}`;
      }
    }

    return (
      <li>
        <a href={link} rel="noopener noreferrer" target="_blank">
          <img className={appname} src={icons[appname]} alt="#" /> Nave for {_.upperFirst(appname)}
        </a>
      </li>
    );
  };

  render() {
    const { className } = this.props;

    return (
      <div
        className={`apps ${className}`}
        ref={(node) => {
          this.node = node;
        }}
      >
        <Button className='apps_logo btn-width-32' 
                variant='secondary'
                size='sm' 
                onClick={this.handleClick}>
          <img src={dashboardIcon} alt="#" />
        </Button>
        <div className='apps_content' style={{ display: this.state.popupVisible ? 'block' : 'none' }}>
          <ul>
            {this.renderApp('jira')}
            {this.renderApp('trello')}
            {this.renderApp('asana')}
            {this.renderApp('azure')}
            {this.renderApp('file')}
          </ul>
        </div>
      </div>
    );
  }
}

Apps.propTypes = {
  className: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
  };
}

export default connect(mapStateToProps)(Apps);
